// src/pages/admin/DirectorChangePage.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import DirectorChangeForm from "../../forms/meeting/Meeting Invitation for Director Change/MeetingInvitationforDirectorChange";

function DirectorChangePage() {
  return (
    <FormWrapper
      title="เชิญประชุมเปลี่ยนกรรมการ"
      FormComponent={DirectorChangeForm}
      formKey="director-change" // key ไว้แยกชื่อไฟล์รูป/เก็บ localStorage ถ้ามี
    />
  );
}

export default DirectorChangePage;
